import PropTypes from 'prop-types';

export default PropTypes.shape({
  hash: PropTypes.string,
  pathname: PropTypes.string,
  search: PropTypes.string,
});
